import React from 'react';

import { action, makeObservable } from 'mobx';

import { toast, Theme, ToastOptions, Slide } from 'react-toastify';

import { SuccessToast } from 'components/Icons/SuccessToast';

import { WarningToast } from 'components/Icons/WarningToast';

import { ErrorToast } from 'components/Icons/ErrorToast';

import { InfoToast } from 'components/Icons/InfoToast';

import { toastCloseButton } from 'components/Icons/ToastCloseButton';

import UndoSnackbar from 'components/UndoSnackbar';

import { colors } from 'theme/colors';

import RootStore from '../Root';

const CloseInfoToast = toastCloseButton(colors.primary.main);
const CloseSuccessToast = toastCloseButton('#2E7D32');
const CloseErrorToast = toastCloseButton(colors.error.main);
const CloseWarningToast = toastCloseButton(colors.warning.main);

class NotificationStore {
  store: RootStore;

  constructor(rootStore: RootStore) {
    makeObservable(this);
    this.store = rootStore;
  }

  commonOptions: ToastOptions = {
    progress: 0.0,
    autoClose: 3000,
    theme: 'colored' as Theme,
    position: toast.POSITION.TOP_CENTER,
    draggable: true,
    pauseOnHover: true,
    closeOnClick: true,
    hideProgressBar: true,
    pauseOnFocusLoss: false,
    transition: Slide,
  };

  @action.bound
  enqueueInfoSnackbar(message: string, options?: ToastOptions): void {
    toast.info(message, { ...this.commonOptions, icon: InfoToast, closeButton: CloseInfoToast, ...options });
  }

  @action.bound
  enqueueSuccessSnackbar(message: string, options?: ToastOptions): void {
    toast.success(message, { ...this.commonOptions, icon: SuccessToast, closeButton: CloseSuccessToast, ...options });
  }

  @action.bound
  enqueueErrorSnackbar(message: string, options?: ToastOptions): void {
    toast.error(message, { ...this.commonOptions, icon: ErrorToast, closeButton: CloseErrorToast, ...options });
  }

  @action.bound
  enqueueWarningSnackbar(message: string, options?: ToastOptions): void {
    toast.warn(message, { ...this.commonOptions, icon: WarningToast, closeButton: CloseWarningToast, ...options });
  }

  @action.bound
  enqueueUndoSnackbar(message: string, { onUndo, autoClose = 6000 }: { onUndo: () => void; autoClose?: number }): void {
    toast.info(React.createElement(UndoSnackbar, { message, onUndo }), {
      ...this.commonOptions,
      autoClose,
      closeOnClick: false,
      icon: InfoToast,
      closeButton: CloseInfoToast,
    });
  }
}

export default NotificationStore;
